import { LOGO_URL } from "@/data/siteData";

export default function BrandMark({ compact = false, testId }) {
  return (
    <span className={`brand-mark ${compact ? "brand-mark--compact" : ""}`} data-testid={testId}>
      <img className="brand-mark__logo" src={LOGO_URL} alt="Gold pelican emblem of Sint Maarten Premier Cleaning" />
      <span className="brand-mark__words">
        <strong>Sint Maarten</strong>
        {!compact && <small>Premier Cleaning Company</small>}
      </span>
    </span>
  );
}
